var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "giftwallContainer",
    staticClass: "giftwall desktop",
    class: {
      'is-open': _vm.isOpenGiftWall
    }
  }, [_c('div', {
    staticClass: "gift-list"
  }, _vm._l(_vm.giftList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "gift-item",
      class: {
        selected: _vm.selectedGiftItemId === item.id,
        locked: _vm.isGiftItemLocked(item)
      },
      on: {
        "mouseover": function mouseover($event) {
          return _vm.showGiftPopup($event, item);
        },
        "mouseout": _vm.hideGiftPopup
      }
    }, [_c('lazy-image', {
      staticClass: "gift-image",
      attrs: {
        "src": item.giftImage
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gift-lock"
    }), _vm._v(" "), item.finanType === '101' ? _c('div', {
      staticClass: "gift-value"
    }, [_vm._v(_vm._s(item.gold))]) : _vm._e(), _vm._v(" "), item.finanType === '102' ? _c('div', {
      staticClass: "gift-xing"
    }, [_vm._v(_vm._s(item.gold))]) : _vm._e(), _vm._v(" "), item.finanType === '103' ? _c('div', {
      staticClass: "gift-diamond"
    }, [_vm._v(_vm._s(item.gold))]) : _vm._e()], 1);
  }), 0), _vm._v(" "), _c('div', {
    ref: "giftswiperContainer",
    staticClass: "gift-swiper gift-swiper-container swiper-no-swiping"
  }, [_c('div', {
    staticClass: "swiper-controls"
  }, [_c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination-wrapper"
  }, [_c('div', {
    ref: "pagination",
    staticClass: "swiper-pagination"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.giftTabs, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide gift swiper-no-swiping"
    }, [_c('div', {
      staticClass: "swiper-giftlist-container swiper-no-swiping"
    }, _vm._l(item.giftList, function (item, index) {
      return _c('div', {
        key: index,
        staticClass: "gift-item",
        class: {
          selected: _vm.selectedGiftItemId === item.id,
          locked: _vm.isGiftItemLocked(item)
        },
        on: {
          "mouseover": function mouseover($event) {
            return _vm.showGiftPopup($event, item);
          },
          "mouseout": _vm.hideGiftPopup
        }
      }, [_c('lazy-image', {
        staticClass: "gift-image",
        attrs: {
          "src": item.giftImage
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "gift-lock"
      }), _vm._v(" "), item.finanType === '101' ? _c('div', {
        staticClass: "gift-value"
      }, [_vm._v(_vm._s(item.gold))]) : _vm._e(), _vm._v(" "), item.finanType === '102' ? _c('div', {
        staticClass: "gift-xing"
      }, [_vm._v(_vm._s(item.gold))]) : _vm._e(), _vm._v(" "), item.finanType === '103' ? _c('div', {
        staticClass: "gift-diamond"
      }, [_vm._v(_vm._s(item.gold))]) : _vm._e()], 1);
    }), 0)]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "gift-popup",
    class: {
      'is-open': _vm.isOpenGiftPopup
    },
    style: {
      left: "".concat(_vm.giftPopupPositionX, "px"),
      top: "".concat(_vm.giftPopupPositionY, "px")
    },
    on: {
      "mouseover": _vm.showGiftPopup,
      "mouseout": _vm.hideGiftPopup
    }
  }, [_c('div', {
    ref: "giftPopupDialog",
    staticClass: "gift-popup-dialog",
    style: {
      left: "".concat(_vm.giftPopupDialogOffset, "px")
    }
  }, [_vm.selectedGiftItemProps ? [_c('div', {
    staticClass: "gift-detail"
  }, [_c('div', {
    staticClass: "gift-image-wrapper"
  }, [_c('lazy-image', {
    staticClass: "gift-image",
    attrs: {
      "src": _vm.selectedGiftItemProps.giftImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gift-description"
  }, [_c('div', {
    staticClass: "gift-title"
  }, [_c('span', {
    staticClass: "gift-name"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemProps.name))]), _c('span', {
    staticClass: "gift-count"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemCount))])]), _vm._v(" "), _vm.selectedGiftItemProps.finanType === '101' ? _c('div', {
    staticClass: "gift-value"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemProps.gold))]) : _vm._e(), _vm._v(" "), _vm.selectedGiftItemProps.finanType === '102' ? _c('div', {
    staticClass: "gift-xing"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemProps.gold))]) : _vm._e(), _vm._v(" "), _vm.selectedGiftItemProps.finanType === '103' ? _c('div', {
    staticClass: "gift-diamond"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemProps.gold))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "gift-counter"
  }, _vm._l(_vm.selectedGiftItemCountList, function (value) {
    return _c('div', {
      key: value,
      staticClass: "gift-counter-item",
      class: {
        selected: value === _vm.selectedGiftItemCount
      },
      on: {
        "click": function click($event) {
          return _vm.selectCurrentGiftItemCount(value);
        }
      }
    }, [_vm._v(_vm._s(value))]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "giftform"
  }, [_c('div', {
    staticClass: "total-amount"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.totalAmount')))]), _vm._v(" "), _vm.selectedGiftItemProps.finanType === '101' ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemCount * _vm.selectedGiftItemProps.gold))]) : _vm._e(), _vm._v(" "), _vm.selectedGiftItemProps.finanType === '102' ? _c('div', {
    staticClass: "xing"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemCount * _vm.selectedGiftItemProps.gold))]) : _vm._e(), _vm._v(" "), _vm.selectedGiftItemProps.finanType === '103' ? _c('div', {
    staticClass: "gift-diamond"
  }, [_vm._v(_vm._s(_vm.selectedGiftItemProps.gold))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('button', {
    staticClass: "submit-button",
    on: {
      "click": function click($event) {
        return _vm.sendGiftRequest();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.send')))])])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "gift-popup-allow"
  })]), _vm._v(" "), _c('button', {
    staticClass: "giftwall-button",
    on: {
      "click": _vm.openGiftWallHandler
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };